import { useMemo } from 'react';

import { AddPeopleDialog } from './add-people-dialog';
import { useAddCustomSkillShares, useCustomSkillShares } from './use-custom-skill-shares';
import type { CustomSkillRecord } from '../../../../../queries/chats';

export function SkillShareDialog({
  skill,
  onClose,
  onChanged,
}: {
  skill: CustomSkillRecord;
  onClose: () => void;
  onChanged: () => Promise<void>;
}) {
  const { shares, reloadShares } = useCustomSkillShares(skill);
  const excludedShareUserUuids = useMemo(() => new Set(shares.map((share) => share.userUuid)), [shares]);
  const handleAddPeople = useAddCustomSkillShares({ skill, reloadShares, onChanged });

  return (
    <AddPeopleDialog open excludedUserUuids={excludedShareUserUuids} onClose={onClose} onAddPeople={handleAddPeople} />
  );
}
